var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "asc__showPage" }, [
    _c("div", { staticClass: "asc__showPage-times" }, [
      _c("i", {
        staticClass: "fas fa-times-circle",
        on: {
          click: function($event) {
            return _vm.closeQuick()
          }
        }
      })
    ]),
    _vm._v(" "),
    _vm.rowData
      ? _c(
          "div",
          { staticClass: "asc__showPage-container" },
          [
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { cols: "12" } }, [
                  _c(
                    "header",
                    [
                      _c("Breadcrumb", {
                        attrs: { title: _vm.rowData.Description1 }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" })
                    ],
                    1
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { cols: "12" } }, [
                  _c("section", [
                    _c("span", [
                      _c("i", { staticClass: "fas fa-code" }),
                      _vm._v(" "),
                      _c("b", [
                        _vm._v(_vm._s(_vm.$t("insert.Voucher.code")) + ":")
                      ]),
                      _vm._v(" " + _vm._s(_vm.rowData.Code))
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _c("i", { staticClass: "fas fa-code" }),
                      _vm._v(" "),
                      _c("b", [
                        _vm._v(
                          _vm._s(_vm.$t("insert.Voucher.description")) + ":"
                        )
                      ]),
                      _vm._v(" " + _vm._s(_vm.rowData.Description1))
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _c("i", { staticClass: "fas fa-check" }),
                      _vm._v(" "),
                      _c("b", [
                        _vm._v(_vm._s(_vm.$t("insert.Voucher.status")) + ":")
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.rowData.Status ? _vm.rowData.Status.Label : ""
                          )
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _c("i", { staticClass: "far fa-circle" }),
                      _vm._v(" "),
                      _c("b", [
                        _vm._v(
                          _vm._s(_vm.$t("insert.Voucher.CustomerId")) + ":"
                        )
                      ])
                    ]),
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.rowData.Customer && _vm.rowData.Customer.Label
                        )
                      )
                    ])
                  ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tabs",
              [
                _c(
                  "b-tab",
                  {
                    attrs: {
                      title: _vm.$t("insert.Voucher.VoucherDetails"),
                      active: ""
                    }
                  },
                  [
                    _c(
                      "b-row",
                      { staticClass: "p-4" },
                      [
                        _c(
                          "b-card",
                          { staticClass: "col-md-6 col-12 asc__showPage-card" },
                          [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.DocumentNumber,
                                    "text",
                                    "get.Voucher.DocumentNumber"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.DocumentDate,
                                    "date",
                                    "get.Voucher.DocumentDate"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.DueDate,
                                    "date",
                                    "get.Voucher.DueDate"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.SerialNumber,
                                    "text",
                                    "get.Voucher.SerialNumber"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.Currency,
                                    "object",
                                    "get.Voucher.CurrencyId"
                                  )
                                )
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-card",
                          { staticClass: "col-md-6 col-12 asc__showPage-card" },
                          [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.CsTotal,
                                    "text",
                                    "get.Voucher.CsTotal"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.Representative,
                                    "object",
                                    "get.Voucher.RepresentativeId"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.rowData.Route,
                                    "object",
                                    "get.Voucher.RouteId"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getFormatDataByType(
                                    _vm.customerReminder,
                                    "text",
                                    "get.Voucher.reminder"
                                  )
                                )
                              }
                            })
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d18499fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d18499fe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Voucher/get.vue
// module id = null
// module chunks = 